<div class="modal-content">
  <!-- Modal body -->
  <div class="modal-body">
    <div class="modal-body-title">
      <img [src]="iconImage" class="image-success" />
      <h4 class="modal-body-title-text">{{title || 'Xác nhận'}}</h4>
    </div>
    <div class="modal-body-message" [innerHTML]="message">
    </div>
    <em>{{subMessage}}</em>
  </div>
  <div class="modal-footer">
    <div class="d-flex justify-content-end align-items-center">
      <a class="btn btn-close mr-4" (click)="cancel()" *ngIf="isCancelButton">{{buttonCancelLabel}}</a>
      <button class="btn btn-ok common__btn" (click)="argree()" *ngIf="isConfirmButton">
        <span> {{buttonLabel}}</span>
      </button>
    </div>
  </div>
</div>